import { useSnackbar } from "notistack";
import { useCallback } from "react";

export function useNotification() {
  const { enqueueSnackbar } = useSnackbar();

  const notifySuccess = useCallback(
    (message: string) => {
      enqueueSnackbar(message, { variant: "success" });
    },
    [enqueueSnackbar]
  );

  const notifyError = useCallback(
    (message: string) => {
      enqueueSnackbar(message, { variant: "error" });
    },
    [enqueueSnackbar]
  );

  return { notifySuccess, notifyError };
}
